/* =================== MÁSCARAS DOS CAMPOS =================== */

// VALOR
$(".valor").mask("000.000.000.000.000,00", { reverse: true });

// CEP
$(".cep").mask("00000-000");

// DATA
$(".data").mask("00/00/0000");

// CPF
$(".cpf").mask("000.000.000-00", { reverse: true });

// CNPJ
$(".cnpj").mask("00.000.000/0000-00", { reverse: true });

// CARTÃO VALIDADE
$(".card-val").mask("00/00");

// CPF OU CNPJ
var cpfCnpj = function (val) {
    return val.length > 14 ? "00.000.000/0000-00" : "000.000.000-009";
  },
  optionsDocumento = {
    onKeyPress: function (val, e, field, options) {
      field.mask(cpfCnpj(val), options);
    },
  };
$(".cpf-cnpj").mask(cpfCnpj, optionsDocumento);

// TELEFONE
var telefoneSP = function (val) {
    return val.replace(/\D/g, "").length === 11
      ? "(00) 00000-0000"
      : "(00) 0000-00009";
  },
  spOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(telefoneSP.apply({}, arguments), options);
    },
  };
$(".telefone").mask(telefoneSP, spOptions);

// CARTÃO DE CRÉDITO
$(".card-numero").mask("0000 0000 0000 0000", { reverse: true });

// CARTÃO DE CRÉDITO (VALIDADE)
$(".card-validade").mask("00/00");

// DATEPICKER
// https://flatpickr.js.org
$(".datepicker").flatpickr({
  dateFormat: "d/m/Y",
  //defaultDate: "today",
  disableMobile: "true",
  locale: {
    weekdays: {
      shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      longhand: [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
      ],
    },
    months: {
      shorthand: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
      longhand: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    },
    rangeSeparator: " até ",
  },
});

function datasEspecificas(date) {
  const rdatedData = $("#datas").data("datasinativas");
  return rdatedData.includes(date.toISOString().substring(0, 10));
}

function datasOff(date) {
  const rdatedDataOff = $("#datas").data("datasoff");
  return rdatedDataOff.includes(date.toISOString().substring(0, 10));
}

function diasEspecificos(date) {
  return (
    date.getDay() === 0 ||
    date.getDay() === 1 ||
    date.getDay() === 4 ||
    date.getDay() === 5 ||
    date.getDay() === 6
  );
}

$(".datepicker-consultoria").flatpickr({
  dateFormat: "d/m/Y",
  //defaultDate: "today",
  disable: [diasEspecificos, datasEspecificas, datasOff],
  minDate: "01.01.2024",
  maxDate: "31.12.2025",
  disableMobile: "true",
  locale: {
    weekdays: {
      shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      longhand: [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
      ],
    },
    months: {
      shorthand: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
      longhand: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    },
    rangeSeparator: " até ",
  },
});

function calculaValorAgendamento(dateString) {
  let dateStringRt = dateString;
  if (dateStringRt != "") {
    let qtDates = dateStringRt.split(",");
    let valorBaseDiaria = $("#valor_base_diaria").val();
    let valorBaseTuorVirtual = $("#valor_base_tuor_virtual").val();
    let tuorVirtual = false;
    if ($("#tourvirtural").is(":checked")) {
      tuorVirtual = true;
    }
    // Calcula
    let valorTotal = valorBaseDiaria * qtDates.length;
    if (tuorVirtual) {
      valorTotal = valorTotal + valorBaseTuorVirtual * qtDates.length;
    }
    console.log(valorTotal);
    if (valorTotal > 0) {
      $(".qtdDias").html(qtDates.length);
      $(".bloco-valor-agendamento").show();
      $(".total_preview").html("$ " + formataMoeda(valorTotal));
    } else {
      $(".bloco-valor-agendamento").hide();
      $(".total_preview").html("");
    }
  } else {
    $(".bloco-valor-agendamento").hide();
    $(".total_preview").html("");
  }
}

$("#tourvirtural").change(function () {
  let datasDatepicker = $(".datepicker-multiple").val();
  if (datasDatepicker != "") {
    calculaValorAgendamento(datasDatepicker);
  }
});

function rmFds(date) {
  return date.getDay() === 0 || date.getDay() === 6;
}
function rmySpecificdays(date) {
  const rdatedData = $("#datas").data("datasinativas");

  let day;
  if (date.getDay() < 10) {
    day = "0" + date.getDay();
  } else {
    day = date.getDay();
  }
  let dataFormt = day + "/" + date.getMonth() + "/" + date.getFullYear();
  console.log(dataFormt);
  console.log(rdatedData.includes(dataFormt));

  return rdatedData.indexOf(dataFormt) !== -1;
}

function isDisable(date) {
  const dateFormated = formatDate(date);
  console.log(dateFormated);
  const rdatedData = $("#datas").data("datasinativas");
  if (rdatedData != null) {
    return rdatedData.includes(dateFormated);
  }
}

function customDates(date) {
  const dateFormated = formatDate(date);
  console.log(dateFormated);
  const rdatedData = $("#datas").data("customdates");
  if (rdatedData != null) {
    return rdatedData.includes(dateFormated);
  }
}

function formatDate(date) {
  let day;
  let month;
  if (date.getDate() < 10) {
    day = "0" + date.getDate();
  } else {
    day = date.getDate();
  }
  if (date.getMonth() + 1 < 10) {
    month = date.getMonth() + 1;
    month = "0" + month;
  } else {
    month = date.getMonth() + 1;
  }
  return day + "/" + month + "/" + date.getFullYear();
}

// Todas as datas indisponíveis
var disablesDates = $("#datas").data("datasinativas");

$(".datepicker-multiple").flatpickr({
  dateFormat: "d/m/Y",
  mode: "multiple",
  minDate: "today",
  maxDate: new Date("2026-12-31"),
  disable: [
    function (date) {
      return (
        ((date.getDay() === 0 || date.getDay() === 6) && !customDates(date)) ||
        isDisable(date)
      );
    },
  ],
  onChange: function (selectedDates, dateStr, instance) {
    /* console.log(selectedDates);
    console.log(dateStr);
    console.log(instance); */
    calculaValorAgendamento(dateStr);
  },
  onDayCreate: function (dObj, dStr, fp, dayElem) {
    var dataObj = dayElem.dateObj;
    var dia =
      dataObj.getDate() < 10 ? "0" + dataObj.getDate() : dataObj.getDate();
    var mes = dataObj.getMonth() + 1;
    var mes = mes < 10 ? "0" + mes : mes;
    var ano = dataObj.getFullYear();
    var data = dia + "/" + mes + "/" + ano;
    if (disablesDates.indexOf(data) !== -1) {
      dayElem.className += " disabled2";
    }
  },
  locale: {
    weekdays: {
      shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      longhand: [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
      ],
    },
    months: {
      shorthand: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
      longhand: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    },
    rangeSeparator: " até ",
  },
});
